import { StyleSheet } from 'react-native';
import { brand, gray_6, gray_1 } from '../../../styles/rn';
var styles = StyleSheet.create({
  inputWrapper: {
    borderWidth: 1,
    borderColor: gray_6,
    borderRadius: 2,
    color: gray_1,
    position: 'relative'
  },
  inputErrWrapper: {
    borderColor: brand
  },
  inputContentWithClearIcon: {
    color: gray_1,
    marginRight: 25,
    marginLeft: 5,
    marginTop: 4,
    marginBottom: 5
  },
  inputContent: {
    marginRight: 5,
    marginLeft: 5,
    marginTop: 2,
    marginBottom: 5
  },
  inputsearchIconContainerStyle: {
    position: 'absolute',
    left: 8,
    top: 8,
    width: 16,
    height: 16
  },
  inputClearIconContainer: {
    position: 'absolute',
    right: 5,
    top: 8,
    width: 16,
    height: 16
  },
  inputClearIcon: {
    width: 16,
    height: 16
  },
  inputErrMsg: {
    color: brand
  }
});
export default styles;